import {dehydrate, QueryClient} from '@tanstack/react-query';
import {GetStaticPropsContext} from 'next';

import {RENDER_MODES} from '@udemy/nextjs-core';

import {CartPage} from 'src/features/cart';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';

import {getStaticAppContext} from '../api/context.api';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

export async function getStaticProps({locale}: GetStaticPropsContext) {
    const staticData = await getStaticAppContext({locale: locale as string});
    const appContext = {
        ...staticData,
    };
    const translations = await getCompactTranslations(locale as string);
    const client = new QueryClient();

    return {
        props: {
            appContext,
            dehydratedState: dehydrate(client),
            locale,
            pageKey: 'cart',
            renderMode: RENDER_MODES.ISR as keyof typeof RENDER_MODES,
            translations,
        },
        revalidate: FOUR_HOURS,
    };
}

export default CartPage;
